$(document).ready(function() {
    $(document).foundation();
});
var OwlSetupPage = OwlSetupPage || {};

(function($, document, undefined) {
    OwlSetupPage.init = function() {
        OwlSetupPage.setupOwl();
    };

    OwlSetupPage.setupOwl = function() {
        var owlTimelineCaro = $('#owl-timeline-caro'),
            owlTimelineNavCaro = $('#owl-timeline-nav-caro'),
            flagTimeline = false,
            duration = 300,
            targetNavItemIndex = 0;


        owlTimelineNavCaro
            .on('change.owl.carousel', function(e) {

                if (!flagTimeline) {
                    flagTimeline = true;
                    console.log('nav caro');
                    owlTimelineCaro.trigger('to.owl.carousel', [e.property.value, duration, true]);
                    flagTimeline = false;
                }
            });

        owlTimelineCaro
            .on('change.owl.carousel', function(e) {
                if (!flagTimeline) {
                    flagTimeline = true;
                    targetNavItemIndex = (e.property.value);
                    owlTimelineNavCaro.trigger('to.owl.carousel', [targetNavItemIndex, duration, true]);
                    owlTimelineNavCaro.find('.selected').removeClass('selected');
                    owlTimelineNavCaro.find('.item').eq(targetNavItemIndex).addClass('selected');
                    flagTimeline = false;
                }
            });

        owlTimelineNavCaro.find('.owl-item').click(function() {
            n = $(this).index();
            owlTimelineCaro.trigger('to.owl.carousel', [n, duration, true]);
        });
    };

    $(function() {
        OwlSetupPage.init();
    });
})(jQuery, document);
var HotjarTriggers = HotjarTriggers || {};

(function ($, document) {

    HotjarTriggers.triggerDelayed = function (event, delay) {
        if ($('body').data('hotjar-enabled') === 'False' || !window.hj) return;

        delay = delay || 500;
        setTimeout(function () {
            hj('trigger', event);
        }, delay);
    }

    HotjarTriggers.trigger = function (event) {
        if ($('body').data('hotjar-enabled') === 'False' || !window.hj) return;

        hj('trigger', event);
    }

})(jQuery, document);
//Header Scripts

var headerPage = headerPage || {};

(function ($, document, undefined) {
    var backToTopSelector = '#backToTop';

    headerPage.init = function() {
        headerPage.initBackToTop();
    };

    headerPage.initBackToTop = function() {
        var backToTopController = new ScrollMagic.Controller();

        var scene = new ScrollMagic.Scene({
            offset: 500
        })
          .setClassToggle("#backToTop", "visible")
          .addTo(backToTopController);

        $(backToTopSelector).click(function (e) {
            e.preventDefault();
            $("body, html").animate({
                scrollTop: 0,
                easing: "easeInOutCubic"
            }, 400);

        });
    };

    $(function () {
        headerPage.init();
    });

})(jQuery, document);
